<div class="modal">
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">Zamenski materijal</h3>
        </div>
        <div class="card-body">
            <div class="form-group">
                <label class="form-label">Naziv materijala</label>
                <app-material-autocomplete (selected)="onSelectMaterial($event)"></app-material-autocomplete>
            </div>
        </div>
        <div class="card-footer text-right">
            <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
            <button class="btn btn-success btn-question" (click)="emitTrue()">Sačuvaj</button>
        </div>
    </div>
</div>

